import { observer } from "mobx-react-lite";
import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import SharedInfluencerProvider from "../../../contexts/Advertiser/SharedInfluencerContext";
import { SidebarCollapseProvider } from "../../../contexts/SidebarCollapseContext";
import { useSidebarCollapse } from "../../../contexts/SidebarCollapseContext";
import Overview from "../../ProjectManager/Influencer/AuthenticationsPageParts/Overview";
import Providers from "../../ProjectManager/Influencer/AuthenticationsPageParts/Providers";
import SocialPosts from "../../ProjectManager/Influencer/AuthenticationsPageParts/SocialPosts";
import Statistics from "../../ProjectManager/Influencer/AuthenticationsPageParts/Statistics";
import Collaborations from "../../ProjectManager/Influencer/AuthenticationsPageParts/Collaborations";
import InfluencerHeader from "../../ProjectManager/Influencer/InfluencerHeader";
import SharedInfluencerSidebar from "./SharedInfluencerSidebar";
import SharedInfluencerHeader from "./SharedInfluencerHeader";

function SharedInfluencerContent() {
  const location = useLocation();
  const { isCollapsed } = useSidebarCollapse();

  return (
    <>
      <SharedInfluencerHeader />
      <SharedInfluencerSidebar />
      <div
        className={`pt-12 ${isCollapsed ? "pl-14" : "pl-56"} dark:bg-rb-dark-mode-background transition-all duration-300`}
      >
        <InfluencerHeader />
        <div className="bg-rb-grey dark:bg-rb-dark-mode-background">
          {!location.pathname.includes("ratings") && (
            <Providers
              isAdvertiserContext={false}
              isInfluencerShareContext={true}
            />
          )}
          <div className="pl-4 pt-4 pr-2 dark:bg-rb-dark-mode-background">
            <Routes>
              <Route path="overview" element={<Overview />} />
              <Route path="statistics" element={<Statistics />} />
              <Route path="social_posts" element={<SocialPosts />} />
              <Route path="collaborations" element={<Collaborations />} />
              <Route path="" element={<Overview />} />
            </Routes>
          </div>
        </div>
      </div>
    </>
  );
}

export default observer(function SharedInfluencerPage() {
  return (
    <SharedInfluencerProvider>
      <SidebarCollapseProvider>
        <SharedInfluencerContent />
      </SidebarCollapseProvider>
    </SharedInfluencerProvider>
  );
});
